export default __webpack_public_path__ + "static/media/ethereum-icon.e7aba6d3.svg";